import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUser from "../fragments/fullUserV4"
import fullTeamV4 from "../fragments/fullTeamV4"

const query = gql`
  query GetUser($id: ID!, $withTeams: Boolean!, $withPreferences: Boolean!) {
    user(id: $id) {
      ...fullUser
      userPreferences @include(if: $withPreferences) {
        birthdayPreferences
      }
      teams @include(if: $withTeams) {
        results {
          ...fullTeam
        }
      }
    }
  }
  ${fullUser}
  ${fullTeamV4}
`

export const getUserKey = getQueryNames(query)[0]

export default query
